import React, { useEffect, useState } from 'react'
import { Row, Col, Form, Dropdown } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { RouteComponentProps, useHistory } from 'react-router-dom'
import { ActionListModal } from '../../../../models/package/actionListModal'
import { IBank } from '../../../../models/systemConfiguration/manageBankAndBranch/ManageBankAndBranch'
import BankAndBranchServices from '../../../../services/systemConfiguration/manegeBankAndBranch/bankAndBranchServices'
import { getUserModuleActions } from '../../../../store/user/selectors'
import {
  ALERT_SUCCESS,
  ALERT_WARNING,
  TOAST_POSITION_TOP_RIGHT,
  TOAST_TRANSITION_SLIDE,
} from '../../../../utils/constants'

import { showTotast } from '../../../../utils/toast'
type TParams = { id: string }
const ViewBank = ({ match }: RouteComponentProps<TParams>) => {
  const [state, setSate] = useState({} as IBank)
  const history = useHistory()

  const actionList = useSelector(
    getUserModuleActions(
      'system-configuration',
      'bank-and-branch',
      'manage-bank'
    )
  )

  const checkPermission = (permissionName: string) => {
    const filterdAction = actionList.filter((action: ActionListModal) => {
      if (action.action.name === permissionName) {
        return action
      }
    })[0]
    if (filterdAction != null) {
      return true
    } else {
      return false
    }
  }

  useEffect(() => {
    async function getData() {
      const result = await BankAndBranchServices.apiGetBank(
        parseInt(match.params.id)
      )
      setSate(result.data)
    }
    getData()
  }, [])

  const handleModify = () => {
    history.push(
      `/system-configuration/bank-and-branch/bank/modify/${match.params.id}`
    )
  }

  let statusAction = ''
  if (state.status == 'Active') {
    checkPermission('inactive') === true && (statusAction = 'Inactive')
  }
  if (state.status == 'Inactive') {
    checkPermission('active') === true && (statusAction = 'Active')
  }
  const handleSelect = async (e: any) => {
    if (e == 'Inactive') {
      const inActiveData = await BankAndBranchServices.apiInactiveBank(
        parseInt(match.params.id)
      )
      let success = false
      let message = inActiveData.errorMessage ? inActiveData.errorMessage : ''
      if (inActiveData.status === 200) {
        success = true
        message = 'Bank successfully inactivated'
      }
      showTotast(
        success ? ALERT_SUCCESS : ALERT_WARNING,
        message,
        TOAST_POSITION_TOP_RIGHT,
        5,
        TOAST_TRANSITION_SLIDE
      )
      setSate(inActiveData.data)
    }
    if (e == 'Active') {
      const activeData = await BankAndBranchServices.apiActiveBank(
        parseInt(match.params.id)
      )
      let success = false
      let message = activeData.errorMessage ? activeData.errorMessage : ''
      if (activeData.status === 200) {
        success = true
        message = 'Bank successfully activated'
      }
      showTotast(
        success ? ALERT_SUCCESS : ALERT_WARNING,
        message,
        TOAST_POSITION_TOP_RIGHT,
        5,
        TOAST_TRANSITION_SLIDE
      )
      setSate(activeData.data)
    }
  }

  return (
    <>
      <Row className="title-layout">
        <Col className="d-flex justify-content-start">
          <img
            src={
              '/src/assets/images/systemConfiguration/supporting-document.svg'
            }
            alt=""
          />
          <span className="m-2">Manage banks</span>
        </Col>
      </Row>
      <Row className="add-Incident-Type-page-layout">
        <Col sm={12} className="border-label">
          <div className="border-label-span">View Bank</div>
          <Form>
            <Row className="mb-4">
              <Col sm={11}>
                <Form.Group className="mb-3" controlId="formGroupTitle">
                  <Form.Label>Status</Form.Label>
                  <Form.Control type="text" disabled value={state.status} />
                </Form.Group>
              </Col>
              <Col sm={1} className="text-align-righ mt-2">
                <Form.Group className="mb-3" controlId="formGroupTitle">
                  <Form.Label></Form.Label>
                  {checkPermission('inactive') === true ||
                  checkPermission('Active') === true ? (
                    <Dropdown onSelect={handleSelect}>
                      <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                        Action
                      </Dropdown.Toggle>
                      <Dropdown.Menu align={{ lg: 'end' }}>
                        <Dropdown.Item eventKey={statusAction}>
                          {statusAction}
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  ) : (
                    ''
                  )}
                </Form.Group>
              </Col>
            </Row>
            <Form.Group className="mb-3" controlId="banCode">
              <Form.Label>Code</Form.Label>
              <Form.Control disabled type="text" value={state.code} />
            </Form.Group>
            <Form.Group className="mb-3" controlId="bankName">
              <Form.Label>Name</Form.Label>
              <Form.Control disabled type="text" value={state.name} />
            </Form.Group>
            <Form.Group className="mb-3" controlId="bankName">
              <Form.Label>Description</Form.Label>
              <Form.Control disabled type="text" value={state.description} />
            </Form.Group>
          </Form>
          <Row>
            <Col sm={12} className="d-flex justify-content-end mt-4">
              <button
                className="cancel-button"
                onClick={(e) => {
                  e.preventDefault()
                  history.goBack()
                }}
              >
                Ok
              </button>
              {checkPermission('modify') === true && (
                <button
                  type="submit"
                  className="save-button"
                  onClick={handleModify}
                >
                  Modify
                </button>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  )
}

export default ViewBank
